// extracted by mini-css-extract-plugin
export default {"selectContainer":"InputCurrency_selectContainer__N4AnD","labelContainer":"InputCurrency_labelContainer__UtKnY"};